import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { TunaPieceCrudService } from 'src/app/shared/services/tuna-piece-crud.service';
import { TunaPiece } from 'src/app/shared/interfaces/tuna-piece';

@Component({
  selector: 'app-tuna-pieces',
  templateUrl: './tuna-pieces.component.html',
  styleUrls: ['./tuna-pieces.component.scss']
})
export class TunaPiecesComponent implements OnInit {

  tunaPieces: TunaPiece[];
  tunaPiece: TunaPiece;
  selectedTunaPieces: TunaPiece[] = [];

  tunaPieceDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private tunaPieceService : TunaPieceCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Tuna Pieces'}
    ];

    this.tunaPieces = [];
    this.tunaPiece = { } as TunaPiece ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.tunaPieceService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.tunaPieces = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : TunaPiece = jsonItem as TunaPiece;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.tunaPieces.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
  //  this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.tunaPieceService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.tunaPieces);
            doc.save('tunaPieces.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.tunaPieces);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "tunaPieces");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedTunaPieces);
      // console.log('SAVEC CSV LOCATIONS ', this.tunaPieces);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedTunaPieces, 'tunaPieces', exportCols);
   // this.exportService.exportToCsv(this.tunaPieces, 'tunaPieces', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.tunaPiece = {} as TunaPiece;
    this.submitted = false;
    this.tunaPieceDialog = true;
  }

  deleteSelectedTunaPieces() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected tunaPieces?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tunaPieces = this.tunaPieces.filter(val => !this.selectedTunaPieces.includes(val));
            
            this.selectedTunaPieces.forEach( tunaPiece => this.tunaPieceService.delete(tunaPiece.$key));
            this.selectedTunaPieces = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPiecess Deleted', life: 3000});
        }
    });
  }

  editTunaPiece(tunaPiece: TunaPiece) {
    this.tunaPiece = {...tunaPiece};
    this.tunaPieceDialog = true;
  }

  deleteTunaPiece(tunaPiece: TunaPiece) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + tunaPiece.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tunaPieces = this.tunaPieces.filter(val => val.$key !== tunaPiece.$key);
            this.tunaPiece = {} as TunaPiece;
            this.tunaPieceService.delete(tunaPiece.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPiece Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.tunaPieceDialog = false;
    this.submitted = false;
  }

  saveTunaPiece() {
    this.submitted = true;

    if ( this.tunaPiece.name.trim() ) {
      if (this.tunaPiece.$key) {
          this.tunaPieces[this.findIndexById(this.tunaPiece.$key)] = this.tunaPiece;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPiece Updated', life: 3000});
          this.tunaPieceService.update(this.tunaPiece);
        } else {
          this.tunaPiece.position = this.tunaPieces.length;
          this.tunaPieceService.add(this.tunaPiece);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'TunaPiece Created', life: 3000});
      this.tunaPieces = [...this.tunaPieces];
    }

    this.tunaPieceDialog = false;
    this.tunaPiece = { } as TunaPiece;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.tunaPieces.length; i++) {
        if (this.tunaPieces[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeTunaPiece(tunaPiece : TunaPiece) {
    this.tunaPieceService.update(tunaPiece);
  }

  completePosition(tunaPiece : TunaPiece) {
    if ( this.newPosition > -1 ) {
        tunaPiece.position = this.newPosition;
        tunaPiece = this.checkPositionLimits(tunaPiece);
        this.reorderElements(tunaPiece);
        //this.updateDB(tunaPiece);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.tunaPieces);
    // const myClonedArray = [];
    // this.tunaPieces.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.tunaPieces.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.tunaPieces.length - 1 - event.dropIndex;
    const tunaPieceToMove = this.tunaPieces[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.tunaPieces[index] = this.tunaPieces[index+1];
        this.tunaPieces[index].position = index;
        this.tunaPieceService.update(this.tunaPieces[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tunaPieces[index] = this.tunaPieces[index-1];
        this.tunaPieces[index].position = index;
        this.tunaPieceService.update(this.tunaPieces[index]);
      }
    } 
    this.tunaPieces[endIndex] = tunaPieceToMove;
    this.tunaPieces[endIndex].position = endIndex;
    this.tunaPieceService.update(this.tunaPieces[endIndex]);
  }

  // onFieldEdit(tunaPiece: Spray, fieldName: string): void {
  //   //console.log(this.tunaPieces);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + tunaPiece[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       tunaPiece.position = this.newPosition;
  //       tunaPiece = this.checkPositionLimits(tunaPiece);
  //       this.reorderElements(tunaPiece);
  //       //this.updateDB(tunaPiece);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(tunaPiece);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.tunaPieces.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, tunaPiece: TunaPiece) {
    // console.log("event" +event);
    if (tunaPiece.position != null && tunaPiece.position > -1) {
      this.previousPosition = tunaPiece.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(tunaPiece: TunaPiece) {
    console.log('check ',tunaPiece.position + ' ' + this.tunaPieces.length);
    if (!tunaPiece.position) {
     // console.log('check 1');
      return this.tunaPiece;
    }
    if (tunaPiece.position < 0) {
      tunaPiece.position = 0;
      // console.log('check 2');
      return tunaPiece;
    }
    if (tunaPiece.position > this.tunaPieces.length) {
      tunaPiece.position = this.tunaPieces.length - 1;
    //  console.log('check 3', tunaPiece.position);
      return tunaPiece;
    }
   // console.log('check 4');
    return tunaPiece;
  }

  async reorderElements(tunaPiece: TunaPiece) {
    this.newPosition = this.newPosition  > this.tunaPieces.length ? this.tunaPieces.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === tunaPiece.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const tunaPieceToMove = this.tunaPieces[startIndex];
   // console.log('Item to move: ', this.tunaPieces[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.tunaPieces);
        console.log('Item to +1: ', this.tunaPieces[index+1]);

        this.tunaPieces[index] = this.tunaPieces[index+1];
        this.tunaPieces[index].position = index;
        // console.log('Move: ', this.tunaPieces[index+1]);
        // console.log('Move pos: ', this.tunaPieces[index].position);
        //await this.updateDB(this.tunaPieces[index]);
        this.tunaPieceService.update(this.tunaPieces[index]);
     //   console.log('Update DB: ', this.tunaPieces[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tunaPieces[index] = this.tunaPieces[index-1];
        this.tunaPieces[index].position = index;
        this.tunaPieceService.update(this.tunaPieces[index]);
      }
    } 
    this.tunaPieces[endIndex] = tunaPieceToMove;
    this.tunaPieces[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.tunaPieceService.update(this.tunaPieces[endIndex]);
    
    // const myClonedArray = [];
    // this.tunaPieces.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.tunaPieces = myClonedArray;
   // this.getAllRecords();
  }
}
